import { DisposerFn } from "@base/util/TypeUtil";

export class Disposers {
  #disposerFn: DisposerFn[] = [];

  push(fn: DisposerFn): void {
    if (fn)
      this.#disposerFn.push(fn);
  }

  dispose(): void {
    for (const t of this.#disposerFn)
      t();
    this.#disposerFn = [];
  }

  get length(): number {
    return this.#disposerFn.length;
  }
}